import { Component, OnInit, OnChanges, Input, Output, EventEmitter, SimpleChange,
  ChangeDetectionStrategy, ViewChild } from '@angular/core';

import * as moment from 'moment';

import { ProjectData, ProjectTask, DinamicProjectForm, FlattenedProjectTask,
  ProjectHourChange, CalendarDateChange, RequestDayEdit
} from '../app.interfaces';

import { WeekTimeTableDialogComponent }   from '../week-time-table-dialog/week-time-table-dialog.component';

@Component({
  selector: 'mcrit-time-table-week',
  templateUrl: './week-time-table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./week-time-table.component.scss']
})
export class WeekTimeTableComponent implements OnInit, OnChanges {
  @Input() year: number;
  @Input() weekNumber: number;
  @Input() projectList: ProjectData[] = [];
  @Input() tipus: string;

  @Output() hourChanges: EventEmitter<ProjectHourChange> = new EventEmitter();
  @Output() dateChange: EventEmitter<CalendarDateChange> = new EventEmitter();

  @ViewChild('dialog') dialog: WeekTimeTableDialogComponent;

  public firstDayWeek: any;
  public formMetadata: Array<DinamicProjectForm>;
  public projectAggregates: Array<FlattenedProjectTask>;
  public selectedDayTasks: Array<ProjectTask> = [];
  public selectedProjectId: number;
  public selectedDay: string = (new Date()).toISOString().slice(0, 10);

  public updateDate($event) {//console.log($event);
    this.firstDayWeek = moment(this.firstDayWeek).locale('ca').add($event.value, $event.type);
    this.year = moment(this.firstDayWeek).locale('ca').year();
    this.weekNumber = moment(this.firstDayWeek).locale('ca').week();
    this.projectAggregates = this.aggregateTaskHours(this.projectList);
    this.dateChange.emit({
      year: this.year,
      weekNumber: this.weekNumber
    });
  }

  public updateTaskRequest($event: ProjectHourChange) {
    this.hourChanges.emit($event);
  }

  private aggregateTaskHours(projectList: Array<ProjectData>): Array<FlattenedProjectTask> {
    return projectList.map((project: ProjectData): FlattenedProjectTask => {
      const dailyHours = new Array(7).fill(0);

      const totalHours = project.taskList.reduce((acum: number, curr: ProjectTask): number => {
        acum += curr.hours;
        return acum;
      }, 0);

      project.taskList.filter(task => {
        return (moment(task.date).locale('ca').year() === this.year && moment(task.date).locale('ca').week() === this.weekNumber);
      })
      .forEach(task => {
        dailyHours[moment(task.date).locale('ca').weekday()] += task.hours;
      });

      return {
        id: project.id,
        code: project.code,
        titol: project.titol,
        totalHours: totalHours,
        dailyHours: dailyHours,
        ambit_proposta: project.ambit_proposta
      };
    });
  }

  public openDayEdit($event: RequestDayEdit) {
    const [ selectedProject ] = this.projectList.filter(item => (item.id === $event.id));
    if (!selectedProject) {
      return;
    }

    this.selectedDayTasks = selectedProject.taskList.filter(item => item.date === $event.date);
    this.selectedProjectId = selectedProject.id;
    this.selectedDay = $event.date
    this.dialog.show();
  }

  constructor(){ this.projectAggregates = this.aggregateTaskHours(this.projectList); }

  ngOnInit() {
    const today = new Date();
    this.year = this.year || today.getFullYear();
    this.weekNumber = this.weekNumber || moment(today).locale('ca').week();
    this.firstDayWeek = moment().locale('ca').year(this.year).weekday(0).week(this.weekNumber);
    this.projectAggregates = this.aggregateTaskHours(this.projectList);
  }

  ngOnChanges(changes: {[propertyName: string]: SimpleChange}) {
    if (changes['weekDays'] || changes['year']) {
      this.year = (changes['year'] && changes['year'].currentValue ?
        changes['year'].currentValue :
        this.year
      );

      this.weekNumber = (changes['weekNumber'] && changes['weekNumber'].currentValue ?
        changes['weekNumber'].currentValue :
        this.weekNumber
      );

      this.firstDayWeek = moment().locale('ca').year(this.year).day(0).week(this.weekNumber);
      this.projectAggregates = this.aggregateTaskHours(this.projectList);
    }

    if (changes['projectList']) {this.projectAggregates = this.aggregateTaskHours(this.projectList);}
  }

}
